// Session token: memory + sessionStorage (per tab, spec §2.2). Never localStorage.
const KEY = "fireslot-bo.token";
let current: string | null = null;

export const tokenStore = {
  get: (): string | null => current,
  load(): string | null {
    try {
      current = sessionStorage.getItem(KEY);
    } catch {}
    return current;
  },
  set(token: string | null): void {
    current = token;
    try {
      if (token) sessionStorage.setItem(KEY, token);
      else sessionStorage.removeItem(KEY);
    } catch {}
  },
};
